import { createContext, useContext, useEffect, useState } from "react";

import { getResponseModel } from "../model/responseModel";
import { routeBase } from "../settings/routerConfig";
import { useToken } from "./TokenContext";

export const RequestContext = createContext();

export const RequestProvider = (props) => {
    const { appKey, appToken } = useToken();
    const [serverHost, setServerHost] = useState(null);

    const errorMessage = "Ocurrió un error al consumir el recurso solicitado";

    const GetServerHost = async () => {
        const apiResponse = await fetch(routeBase + "/serverSettings.json");
        const serverSettings = await apiResponse.json();
        setServerHost(serverSettings?.server);
    };

    const Get = async (payload) => {
        let response = getResponseModel();
        try {
            const api = await fetch(serverHost + payload.url, {
                headers: {
                    "x-api-key": appKey,
                    "x-api-token": appToken,
                },
            });
            response = await api.json();
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
        }
        return response;
    };

    const Post = async (payload) => {
        let response = getResponseModel();
        try {
            const api = await fetch(serverHost + payload.url, {
                method: "POST",
                body: JSON.stringify(payload.body),
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": appKey,
                    "x-api-token": appToken,
                },
            });
            response = await api.json();
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
        }
        return response;
    };

    const PostFormData = async (payload) => {
        let response = getResponseModel();
        try {
            const api = await fetch(serverHost + payload.url, {
                method: "POST",
                body: payload.body,
                headers: {
                    "x-api-key": appKey,
                    "x-api-token": appToken,
                },
            });
            response = await api.json();
        } catch (error) {
            response.Code = -1;
            response.Message = errorMessage;
        }
        return response;
    };

    useEffect(() => {
        GetServerHost();
    }, []);

    return <RequestContext.Provider value={{ serverHost, Get, Post, PostFormData }}>{props.children}</RequestContext.Provider>;
};

export const useRequest = function () {
    return useContext(RequestContext);
};
